import { gql, useFragment } from "@apollo/client";

// Constants
import { bgColorFields, linkFields } from "@/constants/gql-fields";

// Styling
import style from "./header--banner.module.scss";

// Components
import Link from "next/link";
import BackgroundColor from "@/components/bg-color/bg-color";

export default function HeaderBanner({ entry }) {
  // Use Fragment
  const { complete, data } = useFragment({
    fragment: HeaderBanner.fragments.entry,
    fragmentName: "HeaderBannerGenSet",
    from: {
      __typename: entry.__typename,
      id: entry.id,
    },
  });

  if (!complete) {
    return;
  }

  // Define Variables
  const bannerItems = data.headerContent.bannerSettings;
  const bannerLinkType = bannerItems.bannerLinkOptions;

  // Banner Content Button
  var bannerContentButton = "";
  if (bannerLinkType === "button") {
    bannerContentButton = "Button Item";
    const bbTitle = bannerItems.bannerButton.title;
    const bbURL = bannerItems.bannerButton.url;
    const bbTarget = bannerItems.bannerButton.target;
    bannerContentButton = (
      <Link className="btn" href={bbURL} target={bbTarget}>
        {bbTitle}
      </Link>
    );
  }

  // Banner Content
  const bannerContentItem = (
    <div className={`container container--wide ${style.headerBannerContainer}`}>
      <div
        className="banner--content"
        dangerouslySetInnerHTML={{ __html: bannerItems.bannerContent }}
      ></div>
      {bannerContentButton}
    </div>
  );

  return (
    <div
      id="banner"
      className={`${style.headerBanner} ${
        bannerItems.whiteText && style.whiteText
      }`}
    >
      {bannerItems.bannerBackgroundColorColorSettings && (
        <BackgroundColor
          colorSettings={bannerItems.bannerBackgroundColorColorSettings}
        />
      )}
      {bannerLinkType === "whole" && bannerItems.bannerUrl && (
        <Link href={bannerItems.bannerUrl}>{bannerContentItem}</Link>
      )}
      {bannerLinkType !== "whole" && bannerContentItem}
    </div>
  );
}

HeaderBanner.fragments = {
  entry: gql`
    fragment HeaderBannerGenSet on GeneralSettingsACF {
      headerContent {
        bannerSettings {
          bannerContent
          bannerLinkOptions
          bannerUrl
          bannerButton {
            ${linkFields}
          }
          whiteText
          bannerBackgroundColorColorSettings {
           ${bgColorFields}
          }
        }
      }
    }
  `,
};
